import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, share } from 'rxjs';

import { TypeData } from '../interfaces/TypeData';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TypeInfoService {

    private httpOptions = {
        headers: new HttpHeaders({ 'accept': 'application/json' }),
        withCredentials: true
    };

    constructor(private http: HttpClient) { }

    public getListOfTypes(): Observable<{ id: number, type: string }[]> {
        return this.http.get<{ id: number, type: string }[]>(`${environment.typeDataApi}/GetTypesList`, this.httpOptions)
            .pipe(share());
    }

    public getTypeListInfo(): Observable<TypeData[]> {
        return this.http.get<TypeData[]>(`${environment.typeDataApi}/GetTypeData`, this.httpOptions)
            .pipe(share());
    }

    public getTypeInfoByTypes(types: string[]): Observable<TypeData[]> {
        return this.http.post<TypeData[]>(`${environment.typeDataApi}/GetTypeDataByTypes`, { types: types }, this.httpOptions)
            .pipe(share());
    }

    public getTypeInfo(type: string): Observable<TypeData | null> {
        return this.http.get<TypeData>(`${environment.typeDataApi}/GetTypeDataByType/${type}`, this.httpOptions)
            .pipe(share());
    }
}